"use client"

import { useEffect, useRef } from "react"
import { usePathname, useSearchParams } from "next/navigation"

import { useGetCustomer } from "@unlikelystudio/react-ecommerce-hooks"

import LoginPanel from "~/components/ui/Panels/Login"
import { usePanel } from "~/managers/PanelManager"

export function TriggerLoginPanel() {
  const { data: customer, isInitialLoading, isFetching } = useGetCustomer()

  const pathname = usePathname()
  const { add } = usePanel()
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const searchParams = useSearchParams()
  const loggedIn = searchParams?.get("loggedIn")

  useEffect(() => {
    if (!customer && !isFetching && !loggedIn) {
      // I had to do it to have the panel open
      timeoutRef.current = setTimeout(() => {
        add?.(<LoginPanel privateSales={true} returnTo={pathname} />)
      }, 200)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [customer, isInitialLoading])

  return <></>
}
